import {consultantDictionary, DialogSeen} from '../../../../../controls/agyle/clinitian';
import React from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import moment from 'moment/moment';
import keyPerformanceIndicator from '../../../../../util/timeMarker';
import {getConfig} from '../../../../../util/configUtil';
import {ASSESSMENT_BUTTON_COLOURS} from '../../formsUtil';

const SeniorReviewForm = (props) => {
    const {t} = useTranslation();

    // Configs
    const seniorReviewTimeToTreatment = getConfig('seniorReviewTimeToTreatment', false);
    const clinicalNotesFromForm = getConfig('clinicalNotesFromForm', false);

    const handleSeniorReview = (value) => {
        const dataToChange = [{name: 'seniorReview', value: value}];
        if (seniorReviewTimeToTreatment && value?.when) {
            keyPerformanceIndicator(
                dataToChange,
                props.patient,
                ['firstClinicianSaved'],
                {
                    when: value?.when,
                    who: value?.who,
                },
            );
        }
        props.onChange(dataToChange);
    };

    return (
        <DialogSeen
            patient={props.patient}
            size="large"
            label={t('Senior Review Clinician')}
            open={props.open}
            onClose={props.onClose}
            allowedConsultants={consultantDictionary.seniorReview}
            disableSave={props.disableSave}
            color={
                props.patient?.seniorReview?.who
                    ? ASSESSMENT_BUTTON_COLOURS.notMandatorySet
                    : ASSESSMENT_BUTTON_COLOURS.notMandatoryEmpty
            }
            withText
            value={props.patient?.seniorReview || {who: null, when: moment(), text: ''}}
            onChange={handleSeniorReview}
            noteButton={clinicalNotesFromForm}
            noteButtonType="Senior Review"
            refresh
        />
    );
};


export default SeniorReviewForm;